import { render, staticRenderFns } from "./licensesettings.vue?vue&type=template&id=68e7572c"
import script from "./licensesettings.vue?vue&type=script&lang=js"
export * from "./licensesettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports